import React,{useState} from 'react'
import {ImageList, ImageListItem, Grid, Button, Box, Typography, Stack, CircularProgress} from '@mui/material'


import border from '../res/gallery/border.webp'
import box2 from '../res/gallery/box2.webp'
import box8 from '../res/gallery/box8.webp'
import box9 from '../res/gallery/box9.webp'
import card from '../res/gallery/card.webp'
import glass2 from '../res/gallery/glass2.webp'
import label9 from '../res/gallery/label9.webp'
import layer from '../res/gallery/layer.webp'
import mirror2 from '../res/gallery/mirror2.webp'
import pouch from '../res/gallery/pouch.webp'
import topper2 from '../res/gallery/topper2.webp'
import before from '../res/gallery/before.webp'
import cake from '../res/gallery/cake.webp'
import father from '../res/gallery/father.webp'
import gift from '../res/gallery/gift.webp'
import mm from '../res/gallery/mm.webp'
import tenae from '../res/gallery/tenae.webp'
import stickers from '../res/gallery/stickers.webp'


import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Gallery from 'react-grid-gallery';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Image from 'mui-image';

import {Carousel} from 'react-responsive-carousel';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "./styles.css";

// import required modules
import { Autoplay,Pagination, Navigation,Thumbs } from "swiper";

const overlay= (<Box sx={{backgroundColor:'rgba(210,165,90,0.3)',height:'100%', display:'flex'}}></Box>)
// const imgClass=(<Image showLoading  fit='cover'/>)
const PhotoGallery = () => {
  let [set, setSet]=useState(1)
  const theme = useTheme()
  const md_up = useMediaQuery(theme.breakpoints.up('md'));
  const [thumbsSwiper, setThumbsSwiper] = useState(null);



  function useWidth() {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
      keys.reduce((output, key) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null) || 'xs'
    );
  }

  const width = useWidth();
  let imgHeight;
  switch(width){
    case 'xs':
      imgHeight='400px'
      break;
    case 'sm':
      imgHeight='480px'
      break;
    case 'md':
      imgHeight='490px'
      break;
    case 'lg':
      imgHeight='440px'
      break;
    case 'xl':
      imgHeight='500px'
      break;

  }
  const images=[

    {
      original: tenae,
      thumbnail:tenae,
      originalAlt:'Letters',  
    },
    {
      original: glass2,
      thumbnail:glass2,
      originalAlt:'Stemless glass',  
    },
    {
      original: before,
      thumbnail:before,
      originalAlt:'Stemless glass and mug', 
    },
    {
      original: cake,
      thumbnail:cake,
      originalAlt:'Cake topper',   
    },
    {
      original: father,
      thumbnail:father,
      originalAlt:"Father's day",   
    },
    {
      original: gift,
      thumbnail:gift,
      originalAlt:"wine bottle",     
    },
    {
      original: mm,
      thumbnail:mm,
      originalAlt:"m&m",
    },
    {
      original: stickers,
      thumbnail:stickers,
      originalAlt:"custom stickers",
    },
    {
      original: pouch,
      thumbnail:pouch,
      originalAlt:'Custom pouch',
    },
    {
      original: border,
      thumbnail:border,
      originalAlt:'Photo frame',
    
    },
    {
      original: box8,
      thumbnail:box8,
      originalAlt:'Teacher box',
      
    },
    {
      original: card,
      thumbnail:card,
      originalAlt:'Custom card',
      
    },

    {
      original: mirror2,
      thumbnail:mirror2,
      originalAlt:'Personalized mirror',
      
    },

 
    {
      original: box2,
      thumbnail:box2,
      originalAlt:'Custom box',
      
    },

    {
      original: box9,
      thumbnail:box9,
      originalAlt:'Teacher appreciation box',
      
    },
    {
      original: label9,
      thumbnail:label9,
      originalAlt:'Custom birthday box',
      
    },
    {
      original: layer,
      thumbnail:layer,
      originalAlt:'Paper initials',
      
    },

    {
      original: topper2,
      thumbnail:topper2,
      originalAlt:'Birthday topper',
      
    },
    
  ]

  images.map((i)=>{
    // i.originalWidth = '50'
    i.originalHeight=imgHeight
  })

//   const IMAGES =
// [{
//         src: circle1,
//         thumbnail: circle1,
//         thumbnailWidth: 200,
//         thumbnailHeight: 150,
//         customOverlay:overlay
// },
// // {
// //         src: glass2,
// //         thumbnail: glass2,
// //         thumbnailWidth: 320,
// //         thumbnailHeight: 212,
// //         tags: [{value: "Ocean", title: "Ocean"}, {value: "People", title: "People"}],
// //         caption: "Boats (Jeshu John - designerspics.com)"
// // },

// // {
// //         src: bottle,
// //         thumbnail: bottle,
// //         thumbnailWidth: 320,
// //         thumbnailHeight: 212
// // },

// {
//   src: pouch,
//   thumbnail: pouch,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// // {
// //   src: cup1,
// //   thumbnail: cup1,
// //   thumbnailWidth: 320,
// //   thumbnailHeight: 212
// // },
// {
//   src: border,
//   thumbnail: border,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: box8,
//   thumbnail: box8,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: box10,
//   thumbnail: box10,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: card,
//   thumbnail: card,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: label6,
//   thumbnail: label6,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: label7,
//   thumbnail: label7,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: label8,
//   thumbnail: label8,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: label1,
//   thumbnail: label1,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: mirror2,
//   thumbnail: mirror2,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: topper1,
//   thumbnail: topper1,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: glass3,
//   thumbnail: glass3,
//   thumbnailWidth: 400,
//   thumbnailHeight: 300
// },
// {
//   src: flat,
//   thumbnail: flat,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// {
//   src: grad,
//   thumbnail: grad,
//   thumbnailWidth: 320,
//   thumbnailHeight: 212
// },
// ]
// IMAGES.map((i)=>{i.customOverlay = overlay})



  return (
    // <Grid container alignItems="center" >
    //   <Grid container item  justifyContent="flex-start" xs={2}><Button onClick={()=>{if(set>0)setSet(0);setSet(1)}}>Back</Button></Grid>

    //   <Grid item  xs={8}>
    //     {set>0?(
    //         <ImageList
    //         sx={{ width: '600px', height: '600px' }}
    //         variant="masonry"
    //         cols={3}
            
    //         rowHeight={400}
    //       >
    //         {itemData.map((item) => {if(set==item.set)return(
    //           <ImageListItem key={item.img} >
    //             <img
    //               // {...srcset(item.img, 200, item.rows, item.cols)}
    //               src={item.img}
    //               alt={item.title}
    //               loading="lazy"
    //               style={{width:'100%', height:'100%', objectFit:'cover'}}
    //             />
    //           </ImageListItem>
    //         )})}
    //       </ImageList>
    //     ):null}
      


    //   </Grid>


    //   <Grid container justifyContent="flex-end" item xs={2}><Button onClick={()=>{if(set<3)setSet(0);setSet(2)}}>Next</Button></Grid>
    

    // </Grid>

    // <Grid container direction='column'
    // sx={{
    //   borderRadius:4,
    //   display: 'flex',
    //   alignItems:'center',
    //   padding:1}}
    //   alignItems='center'
    // >
    //   {/* {!xl_down?
    // <Gallery enableImageSelection={false} margin={1} backdropClosesModal={true} rowHeight={277} images={IMAGES} customOverlay={overlay}/>:
    // <ImageGallery originalHeight='100px' items={images} showThumbnails={false} showBullets={true} autoPlay={true} slideDuration={750} slideInterval={4000}/> */}
    // {/* } */}
    // {/* <Grid container item xs={2} justifyContent='center' alignItems='center' sx={{pb:4}}>
    //   <Typography variant='h2' align='center' color='secondary.dark'>Gallery</Typography>
    // </Grid> */}
    
    // <Grid container item xs={12 } alignItems='center' justifyContent='center'>
    //   <Grid item xs={10}>
    //     <ImageGallery items={images} showFullscreenButton={false} showThumbnails thumbnailPosition='bottom'
    // showBullets={false} autoPlay={true} slideDuration={750} slideInterval={4600}/>
    //   </Grid>
    

    // {/* <Gallery enableImageSelection={false} margin={1} backdropClosesModal={true} rowHeight={277} images={IMAGES} customOverlay={overlay}/> */}

    
    // </Grid>
      
    
    // </Grid>
    <Box >
      <Box sx={{height:{xs:'35vh',md:'70vh'},pb:1}} width="90vw" alignItems='center' justifyContent='center' display='flex' >
    <Swiper
        style={{
          "--swiper-navigation-color": "#f7799c",
          "--swiper-pagination-color": "#fff",
        }}
        navigation={true}
        modules={[ Autoplay,Navigation, Thumbs]}
        className={md_up?'mySwiper':'mySwiper_xs'}
        slidesPerView={'1.5'}
        // spaceBetween={10}
        centeredSlides={true}
        thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        
      >

        {images.map((image,i)=>(
          <SwiperSlide>
            {/* <Box height={1} width={'4000px'} alignItems='center' justifyContent='center'> */}
              <Image src={image.original}  shift='left' showLoading={<CircularProgress/>}  fit={md_up?'contain':'contain'}/>
            {/* </Box> */}
            
          </SwiperSlide>
        ))}
      </Swiper>

      
 </Box>

 <Box height={{xs:'0vh',sm:"10vh"}} width="75vw" alignItems='center' justifyContent='center' display='flex'>
    <Swiper
        
        onSwiper={setThumbsSwiper}
        navigation={false}
        modules={[ Thumbs,Navigation]}
        className='mySwiper2'
        slidesPerView={'auto'}
        spaceBetween={10}
        // watchSlidesProgress={true}
        centeredSlides={true}
        loop={true}
        
        
      >

        {images.map((image,i)=>(
          <SwiperSlide>
            <Box width='1'height='1' display={{xs:'none',sm:'none'}}>
            <Image src={image.original} key ={i} showLoading={<CircularProgress/>} fit='cover'/>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      
 </Box>
    </Box>
  )
}

export default PhotoGallery